import { GetCancellationToken } from "../../utility/HttpServiceUtility";
import { useFeatureFlagService } from "../../api/ServiceContext";
import { useEffect, useState } from "react";
import { FeatureFlagModel } from "../../apiModels/FeatureFlag/FeatureFlagModel";
import { useDispatchAlert } from "../UI/Alert";
import { useTranslation } from "react-i18next";

export function useFeatureFlagsHooks()
{
    const cancellationToken = GetCancellationToken();
    const featureFlagService = useFeatureFlagService(cancellationToken);
    const dispatchAlert = useDispatchAlert();
    const { t } = useTranslation();

    const [featureFlags, setFeatureFlags] = useState<FeatureFlagModel | null>(null);
    const [awaitingResponse, setAwaitingResponse] = useState(true);

    useEffect(() => {
        setAwaitingResponse(true);

        featureFlagService.getFeatureFlags() 
            .then(response => {
                setFeatureFlags(response);
                setAwaitingResponse(false);
            })
            .catch((error_) => {
                if (!error_.isCancelled) {
                    dispatchAlert({
                        message: t("generic.errorMessage"),
                        messageType: "error",
                    });
                }
            });

        return () => {
            cancellationToken.cancel();
        };
    }, []);

    return {
        featureFlags: featureFlags,
        awaitingResponse: awaitingResponse,
    };
}